import React, { useState } from 'react';

function FetchComponent() {
  const [requestId, setRequestId] = useState('');
  const [result, setResult] = useState(null);
  const [referenceNo, setReferenceNo] = useState(null);
  const [url, setUrl] = useState(null);


  const handleFetch = () => {
    const myHeaders = new Headers();
    myHeaders.append("x-api-key", "pbaVV0yEEa7lfFKLW0diKauRKt1HouiY2UI0m5Yt");
    myHeaders.append("key", "79993401FEAD58EE8B4965C62CCE60E4");
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      "request_id": requestId
    });

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    fetch("https://zvy6evtfrl.execute-api.ap-south-1.amazonaws.com/v1/upload/generate", requestOptions)
      .then(response => response.json())
      .then(data => {
        if (data.status && data.data && data.data.reference_no) {
          setReferenceNo(data.data.reference_no);
          console.log(data.data.reference_no)
        }
        if (data.status && data.data && data.data.url) {
            setUrl(data.data.url);
          }
      })
      .catch(error => console.log('error', error));
  };
  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (file && file.type === "application/pdf") {
      const reader = new FileReader();
      reader.onload = (event) => {
        const binaryString = event.target.result;
        // Send this binaryString as payload to the url
        fetch(url, {
          method: 'PUT',
          body: binaryString,
        })
        .then(response => {
          if(response.ok) {
            console.log("Upload successful");
            alert("Uploaded Successfully")
          } else {
            console.log("Upload failed");
          }
        })
        .catch(error => console.log('error', error));
      };
      reader.readAsArrayBuffer(file);
    } else {
      console.log("Please select a valid PDF");
    }
  };
  function copyToClipboard() {
    const el = document.getElementById("referenceNoInput");
    el.select();
    document.execCommand('copy');
    alert("copied successfully")
}

return (
    <div style={{ fontFamily: 'Arial', padding: '20px' }}>
      
      {/* Request ID Input */}
      <div style={{ marginBottom: '20px' }}>
        <input
          type="text"
          value={requestId}
          onChange={e => setRequestId(e.target.value)}
          placeholder="Enter request ID"
       
        />
        <br/>
        <br/>

        <button onClick={handleFetch} style={{
          padding: '10px 20px',
          backgroundColor: '#ef4f28',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Fetch Data
        </button>
      </div>

      {/* Reference No Input */}
      {referenceNo && 
      <div style={{ marginBottom: '20px' }}>
          <input 
              type="text" 
              id="referenceNoInput" 
              value={referenceNo} 
              readOnly 
              onClick={copyToClipboard} 
              style={{
                padding: '10px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                width: '80%',
                marginRight: '10px',
                cursor: "pointer"
              }}
          />
          <span style={{ fontSize: '0.9em', color: 'gray' }}>(Click to copy)</span>
      </div>} 
      
      {/* File Upload */}
      {url && (
      <div style={{ marginBottom: '20px' }}>
        <input 
          type="file" 
          accept=".pdf" 
          onChange={handleFileUpload} 
          style={{
            padding: '10px',
            borderRadius: '4px',
            border: '1px solid #ccc'
          }}
        />
      </div>
      )}

    </div>
);

}

export default FetchComponent;